import React from 'react';
import Translate from '@spordle/intl-elements';

import Table from '../Table';
import Loader from '../Loader';

import { TableHeader, TableRow } from './StandingsTableBody';

export default ({ currentRows, groups, status, statuses = [ status ], filters, schedule, hideCategory, showSportsmanship, highlightRow, properties, disableSorting, querySort, queryOrder, handleSorting, ...props }) =>
  <Table
    className="standings-table"
    groups={groups}
    filters={filters}
    renderMessage={() => {
      if (!filters) return null;
      if (statuses.every(status => status === 'idle') || !filters.scheduleId) return <p><Translate id="components.standings.select.schedule" /></p>
      if (statuses.includes('error')) return <p><Translate id="components.standings.loading.fail" /></p>
      if (statuses.includes('loading')) return <Loader><Translate id="components.standings.loading" /></Loader>
      if (!currentRows?.length) return <p><Translate id="components.standings.no.standings" /></p>
      return null;
    }}
    renderHeader={({ isMobile }) =>
      <TableHeader
        isMobile={isMobile}
        properties={properties}
        disableSorting={disableSorting}
        querySort={querySort}
        queryOrder={queryOrder}
        handleSorting={handleSorting}
      />
    }
    renderGroupHeader={group => {
      if (!group?.id) return null;
      return <tr key={group.id}>
        <th colSpan={17} scope="colgroup">{group.name}</th>
      </tr>
    }}
    highlightRow={highlightRow}
    renderRow={({ isMobile, row: teamStat, index, highlight }) =>
      <TableRow
        key={teamStat.id || teamStat.teamId}
        index={index}
        stats={teamStat}
        isMobile={isMobile}
        showSportsmanship={showSportsmanship}
        highlight={highlight}
        properties={properties}
      />
    }
    {...props}
  />
